import { useProductType } from '../services/ProductTypesManager'
import { useEffect } from 'react'
import { isValidForProductType } from '../stores/promoCodeSlice/promoCodeUtils'
import { promoCodeManager } from '../services/PromoCodeManager'

export const useSetInitialCoupon = () => {
  const { productType } = useProductType()

  useEffect(() => {
    // Update promo code if it is not valid for the current product
    // Use last valid promo code if available
    if (
      !isValidForProductType(promoCodeManager.getDiscountCoupon(), productType)
    ) {
      const validPromo = promoCodeManager
        .getAllDiscountCoupons()
        .slice()
        .reverse()
        .find((coupon: object) => isValidForProductType(coupon, productType))
      promoCodeManager.setDiscountCoupon(validPromo || null)
    }
  }, [productType])
}
